var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
import ClientService from '../../api/ClientService';
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.groups = [];
        _this.group = null;
        _this.clientIds = null;
        return _this;
    }
    Dialog.prototype.created = function () {
        this.service = ClientService.getInstance();
        this.getGroups();
    };
    Dialog.prototype.getGroups = function () {
        var _this = this;
        this.service.getGroups().then(function (res) {
            var data = res.data.data;
            _this.groups = data || [];
            if (data && data.length && !_this.group) {
                _this.group = data[0].group_id;
            }
        });
    };
    Dialog.prototype.close = function () {
        this.$closeDialog();
    };
    Dialog.prototype.submitData = function () {
        var _this = this;
        this.service.changeGroup({
            supplier_to_business_id: this.clientIds,
            group_id: this.group
        }).then(function (res) {
            if (res.data.success) {
                _this.$message.success('修改成功！');
                _this.close();
                _this.$emit('changeGroups:ok');
                window._czc.push(["_trackEvent", '合作客户列表', '转移客户']);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        });
    };
    Dialog = __decorate([
        Component
    ], Dialog);
    return Dialog;
}(VueDialog));
export default Dialog;
